import { User } from '@core/states/user/user-state.model';

export const userDataMock = new User(
  '123456',
  'b2c123456',
  'null',
  'John Smith',
  'John',
  'Smith',
  'john.smith@cae.com'
);
